import { Info, WifiOff } from "lucide-react";
import { Button } from "../Button";

export function ApiFallbackBanner({
  onRetry,
  message = "API indisponible - affichage des donnees locales.",
  actionLabel = "Reessayer",
  tone = "warning",
}: {
  onRetry?: () => void;
  message?: string;
  actionLabel?: string;
  tone?: "warning" | "info";
}) {
  const Icon = tone === "info" ? Info : WifiOff;
  const styles =
    tone === "info"
      ? "border-info/30 bg-info-dim text-info"
      : "border-warning/30 bg-warning-dim text-warning";

  return (
    <div className={`flex items-center justify-between gap-3 mb-4 rounded-sm border px-3.5 py-2.5 text-[12px] ${styles}`}>
      <span className="flex items-center gap-2">
        <Icon className="h-3.5 w-3.5" />
        {message}
      </span>
      {onRetry && (
        <Button variant="ghost" size="xs" onClick={onRetry}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
